import { RootState } from "../../../store";

export const currentBudgetDataLoadingSelector = (state: RootState): boolean => {
  return state.budgets.currentBudgetDataLoading;
};
